import styled from 'styled-components'
import { theme } from '../../../../../styles/theme'

export const Container = styled.form`
  width: 100%;

  display: grid;
  grid-template-columns: 2fr 1fr;
`

export const FormWrapper = styled.div`
  height: 100%;
  padding: 100px 80px 60px 35px;

  background: ${theme.colors.lightGray};
`

export const OrganizationWrapper = styled.div`
  padding: 100px 70px;
`

export const OptionModelWrapper = styled.div`
`
